<i18n>
{
  "fr":{
    "Name": "Nom du programmeur",
    "StartDate": "Date de début",
    "EndDate": "Date de fin"
  }
}
</i18n>

<template>
  <section>
    <BaseForm @submit="generate()">
      <UserPicker
        v-model="form.user"
        source="DevOps"
        @input="generate" />
    </Baseform>
  </section>
</template>

<script>
import UserPicker from './UserPicker';

export default {
  components: {
    UserPicker,
  },
  data() {
    return {
      form: {
        user: null,
      },
    };
  },
  created() {
    if (this.form.user) {
      this.generate();
    }
  },
  methods: {
    async generate() {
      this.$emit('submit', {
        user: this.form.user,
      });
    },
  },
};
</script>
